import type { ListItem } from 'mdast';

import { MALFORMED_CHECKBOX_REGEX } from './malformed-checkbox-regex';

/**
 * Returns true if the list item should be treated as a task item even though
 * remark-gfm set checked: null (malformed checkbox with no/trailing content).
 */
export function isMalformedTaskItem(node: ListItem): boolean {
	if (node.children.length === 0) {
		return false;
	}
	const firstChild = node.children[0];
	if (firstChild.type !== 'paragraph' || firstChild.children.length === 0) {
		return false;
	}
	const firstInline = firstChild.children[0];
	return firstInline.type === 'text' && MALFORMED_CHECKBOX_REGEX.test(firstInline.value);
}
